import React, { useEffect, useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { RiHomeFill } from 'react-icons/ri';
import { IoIosArrowForward, IoIosSettings, IoIosAdd } from 'react-icons/io';
import logo from '../assets/newLogo.JPG';
import { familyQuery } from '../utils/data';
import { client } from '../client';


const isNotActiveStyle = 'flex items-center px-2 gap-3 text-black hover:text-black transition-all duration-200 ease-in-out capitalize';
const isActiveStyle = 'flex items-center px-2 gap-3 font-extrabold border-r-2 border-black  transition-all duration-200 ease-in-out capitalize';

const Sidebar = ({ closeToggle, user }) => {
  const [families, setFamilies] = useState();
  const id = '\'' + user?._id + '\'';
  const navigate = useNavigate();

  useEffect(() => {
    const query = familyQuery(id);

    client.fetch(query).then((data) => {
      setFamilies(data);
    });

  }, [id])


  const handleCloseSidebar = () => {
    if (closeToggle) closeToggle(false);
  };

  return (
    <div className="flex flex-col justify-between bg-white h-full overflow-y-scroll min-w-210 hide-scrollbar">
      <div className="flex flex-col">
        <Link
          to="/"
          className="flex items-center"
          onClick={handleCloseSidebar}
        >
          <img src={logo} alt="logo" className="w-20 h-20" />
        </Link>
        <div className="flex flex-col gap-5">

          {/* <NavLink
            to="/"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={handleCloseSidebar}
          >
            <RiHomeFill />
            Home
          </NavLink> */}
          <div className='flex items-center justify-between border-b-2 border-gray-200 px-2 gap-3'>
            <h3 className=" px-5 text-base 2xl:text-xl">Family Groups </h3>
            <button
              type="button"
              onClick={(e) => {
                navigate('/family')
                handleCloseSidebar()
              }}
              className='bg-indigo-500 text-black font-bold p-2 rounded-full w-auto m-1 outline-none'
            >
              <IoIosAdd />
            </button>
          </div>
          {families?.map((family) =>
            <div className='flex  items-center justify-between px-2 gap-3'>
              <NavLink
                to={`/category/${family?._id}`}
                className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
                onClick={handleCloseSidebar}
                key={family.familyName}
              >
                <img src={family.imageUrl + "?h=40"} className="w-8 h-8 rounded-full shadow-sm" />
                {family.familyName}
              </NavLink>
              <NavLink
                className='bg-indigo-500 text-black font-bold p-2 rounded-full w-auto m-1 outline-none'
                to={`/family-detail/${family?._id}`}
                onClick={handleCloseSidebar}
                key={family?._id}
              >
                <IoIosSettings />
              </NavLink>
            </div>
          )}
        </div>
      </div>
      {user && (
        <Link
          to={`user-profile/${user._id}`}
          className="flex my-5 mb-3 gap-2 p-2 items-center bg-white rounded-lg shadow-lg mx-3"
          onClick={handleCloseSidebar}
        >
          <img src={user.profUrl} className="w-10 h-10 rounded-lg" alt="user-profile" />
          <p>{user.userName}</p>
          <IoIosArrowForward />
        </Link>
      )}
    </div>
  );
};

export default Sidebar;

